'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dispatcher = undefined;

var _isFunction2 = require('lodash/isFunction');

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dispatcher;

exports.default = fireMiddleware;

var _reduxField = require('redux-field');

var _actions = require('./actions');

var _actionHandlers = require('./actionHandlers');

var _util = require('./util');

var _select = require('./select');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var dispatcher = exports.dispatcher = (_dispatcher = {}, _defineProperty(_dispatcher, _actions.AUTH, _actionHandlers.handleAuth), _defineProperty(_dispatcher, _actions.DELETE_ENTITY, (0, _actionHandlers.sendPayload)(_util.entityDelete)), _defineProperty(_dispatcher, _actions.DELETE_TRIPLE, (0, _actionHandlers.sendPayload)(_util.tripleDelete)), _defineProperty(_dispatcher, _actions.LOGOUT, _actionHandlers.handleLogout), _defineProperty(_dispatcher, _actions.SAVE_ENTITY, (0, _actionHandlers.sendPayload)(_util.entitySet)), _defineProperty(_dispatcher, _actions.SAVE_TRIPLE, _actionHandlers.handleTriplePut), _defineProperty(_dispatcher, _reduxField.SUBMIT, _actionHandlers.handleFieldSubmit), _defineProperty(_dispatcher, _actions.UPDATE_ENTITY, (0, _actionHandlers.sendPayload)(_util.entityUpdate)), _defineProperty(_dispatcher, _actions.UPLOAD_FILE, _actionHandlers.handleFileUpload), _dispatcher);

function fireMiddleware(firebase) {
  var handlers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var actions = _extends({}, dispatcher, handlers);
  return function (store) {
    return function (next) {
      return function (action) {
        if (!action.type) return next(action);
        if ((0, _isFunction3.default)(actions[action.type])) {
          var entityIds = (0, _select.getEntityTypes)(store.getState());
          return actions[action.type]({ action: action, entityIds: entityIds, firebase: firebase, next: next, store: store });
        }
        return next(action);
      };
    };
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cape-firebase/lib/middleware.js
// module id = 654
// module chunks = 0